import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./BackLink.module.styl";

function BackLink({ to, text, name }) {
    return (
        <Link className={styles.backLink} to={to} data-test-name={name}>
            ←{text}
        </Link>
    );
}

BackLink.propTypes = {
    to: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    name: PropTypes.string,
};

export default BackLink;
